import { styled } from '@mui/system'
import GlobalAlert from './view/components/dialogs/GlobalAlert'
import LayerDialog from './view/containers/LayerDialog'
import SnackBar from './view/components/snackbars/SnackBar'
import { DemoRoutes } from './mocks/demo-pages/DemoRoutes'

// 社外向けデモ専用エントリ。本番のApp.tsxが前提とする認証フロー
// （TenantPrivateによるテナント切替・契約同意チェック・プロジェクト割当取得等）は
// 経由しない。SideMenu・UserInformationHeaderは認証済みRedux state・API呼び出しに
// 依存するため使用できず、DemoRoutes内で見た目のみのMock版に差し替えて表示する。
// LayerDialog（グリッドのアイコンクリックで開く単票画面）や、無効化した機能の
// 通知に使うSnackBarは機能そのものに必須のため残す。
const RootContainer = styled('div')({
  display: 'flex',
  height: '100%',
  width: '100%',
  overflow: 'hidden',
})

export const DemoApp = () => (
  <RootContainer>
    <GlobalAlert />
    <DemoRoutes />
    <LayerDialog depth={1} />
    <SnackBar />
  </RootContainer>
)
